export default "__VITE_ASSET__C7U_WVZI__"